import {convertFromHTML, ContentState, convertToRaw} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import VoucherService from '../../services/Voucher/voucher.service';
import success from '../../constants/success';
import {Chip} from '../../components';
import {ColorType} from '../../types/typeChip';
import React from 'react';
import {Typography} from '../../pages/voucher/Voucher.style';
import {formatLocalDateFromUTCTime} from '..';
import {IsNullOrEmptyOrUndefined} from '../helpers';

export const limitQuantity = 40;
// Section props begin
export const TicketAddNewDefaultParams = {
  title: '',
  description: '',
  excerpt: '',
  usageType: 1,
  cost: 0,
  quantity: 0,
  unlimitedQuantity: false,
  onlinePurchaseURL: '',
  amountOffset: 0,
  type: 1,
  priority: false,
  startOfDateTime: null,
  endOfDateTime: null,
  isExclusive: 0,
  isCashoutAllowed: false,
  targetedDistribution: 0,
  quantityMaxPerRedemption: 1,
};

export const TicketUsageTypeEnums = {
  DEFAULT: 0,
  SINGLE_NON_REPEATABLE: 1,
  SINGLE_REPEATABLE: 3,
  MULTI_REDEMPTION: 2,
};

export const ticketUsageTypeRadioOptions = {
  [TicketUsageTypeEnums.DEFAULT]: {
    key: '--',
    caption: '',
    value: TicketUsageTypeEnums.DEFAULT,
  },
  [TicketUsageTypeEnums.SINGLE_NON_REPEATABLE]: {
    key: 'Single, non-repeatable',
    caption:
      'Redeem one quantity, use once, not eligible for <br/> repeat redemption',
    value: TicketUsageTypeEnums.SINGLE_NON_REPEATABLE,
  },
  [TicketUsageTypeEnums.SINGLE_REPEATABLE]: {
    key: 'Single, repeatable',
    caption:
      'Redeem one quantity, use once, eligible for <br/> repeat redemption',
    value: TicketUsageTypeEnums.SINGLE_REPEATABLE,
  },
  [TicketUsageTypeEnums.MULTI_REDEMPTION]: {
    key: 'Multi-redemption',
    caption:
      'Redeem multiple quantities, use one at a time, <br/> eligible for repeat redemption',
    value: TicketUsageTypeEnums.MULTI_REDEMPTION,
  },
};

export const TicketVisibilityEnums = {
  PUBLIC: 0,
  TARGETED: 1,
};

export const radioTicketVisibilityOptions = [
  {
    key: 'Public',
    value: TicketVisibilityEnums.PUBLIC,
  },
  {
    key: 'Targeted',
    value: TicketVisibilityEnums.TARGETED,
  },
];
// Section props end
// Section func begin
export const viewSourceHtmlEditor = (data: string, value: string) => {
  let result = '';
  let contentString = '';

  const contentHTML = convertFromHTML(data);
  const states = ContentState.createFromBlockArray(
    contentHTML.contentBlocks,
    contentHTML.entityMap
  );
  JSON.parse(
    value !== '' ? value : JSON.stringify(convertToRaw(states))
  ).blocks.map(item => (contentString = contentString + item.text));
  if (contentString.search('</') !== -1) {
    const contentHTML = convertFromHTML(data);
    const state = ContentState.createFromBlockArray(
      contentHTML.contentBlocks,
      contentHTML.entityMap
    );
    result = JSON.stringify(convertToRaw(state));
  } else {
    const state = ContentState.createFromText(data);
    result = JSON.stringify(convertToRaw(state));
  }

  return result;
};

export const onChangeEditor = (
  e: any,
  values: any,
  handleChange: (content: any) => {}
) => {
  let stringContent = '';
  e.getCurrentContent()
    .getBlocksAsArray()
    .map(item => (stringContent = stringContent + item.text));
  let content =
    stringContent.search('</') === -1
      ? stateToHTML(e.getCurrentContent())
      : stringContent;
  content = content.replace('<strong>', '<b>');
  content = content.replace('</strong>', '</b>');
  handleChange(content === '<p><br></p>' ? '' : content);
  return {
    ...values,
    description: content === '<p><br></p>' ? '' : content,
  };
};

export const createNewVouchers = async (
  params: object,
  voucherImages: any[]
): Promise<any> => {
  const res = await new VoucherService().create(params);

  if (res && res.success) {
    if (voucherImages.length > 0) {
      // Upload images and return the result
      const resImg = await new VoucherService().uploadImage(
        res.data.id,
        new File(voucherImages, 'voucherImage.jpeg', {
          type: voucherImages[0]?.type,
        })
      );
    }
    return {
      code: 200,
      success: true,
      message: success.CREATE_SUCCESS,
      isClose: true,
      isReloadPage: true,
    };
  } else {
    return {
      code: 400,
      success: false,
      message: res.errorMessage,
      isClose: false,
      isReloadPage: false,
    };
  }
};

export const updateVoucher = async (
  idDetail: string,
  params: object,
  voucherImages: any[]
) => {
  const res = await new VoucherService().update(idDetail, params);

  if (res && res?.success) {
    if (voucherImages.length > 0 && typeof voucherImages[0] !== 'string') {
      const resImg = await new VoucherService().uploadImage(
        res.data.id,
        new File(voucherImages, 'voucherImage.jpeg', {
          type: voucherImages[0]?.type,
        })
      );
      if (resImg) {
        return {
          code: 200,
          message: success.UPDATE_SUCCESS,
          success: true,
        };
      }
    } else {
      return {
        code: 200,
        message: success.UPDATE_SUCCESS,
        success: true,
      };
    }
  } else {
    return {
      code: 400,
      message: res.errorMessage,
      success: false,
    };
  }
};

export const getVoucherDetail = async (idDetail: string) => {
  const res = await new VoucherService().getOne(idDetail).then(res => res);
  return res;
};

export const getVouchers = async (params: object) => {
  const res = await new VoucherService().getAll(params).then(res => res);
  return res;
};

export const getFeaturedVouchers = async (params: object) => {
  const res = await new VoucherService().getAll(params).then(res => res);
  return res;
};

export const renderTicketStatus = value => {
  if (IsNullOrEmptyOrUndefined(value)) return '--';
  const isDeleted = value?.status === 2;
  if (
    new Date().toISOString() <=
      new Date(value?.expireEndDateTime).toISOString() &&
    new Date().toISOString() >=
      new Date(value?.expireStartDateTime).toISOString() &&
    !isDeleted
  ) {
    return <Chip label="Available" color={'success' as ColorType} />;
  }
  if (
    new Date(value?.expireStartDateTime).toISOString() >=
      new Date().toISOString() &&
    !isDeleted
  ) {
    return <Chip label="Coming" color={'warning' as ColorType} />;
  }
  if (
    new Date(value?.expireEndDateTime).toISOString() <=
      new Date().toISOString() &&
    !isDeleted
  ) {
    return <Chip label="Expired" color={'error' as ColorType} />;
  }
  if (isDeleted) {
    return <Chip label="Deleted" color={'default' as ColorType} />;
  }
};

export const renderTicketValidity = (values, formatTime: string) => {
  if (values) {
    return (
      <>
        <Typography variant="inherit">
          {formatLocalDateFromUTCTime(values.expireStartDateTime, formatTime)} -
        </Typography>
        <Typography variant="inherit">
          {formatLocalDateFromUTCTime(values.expireEndDateTime, formatTime)}
        </Typography>
      </>
    );
  }
};

export const renderTicketExclusiveType = values => {
  if (!values) return '--';
  switch (values.isExclusive) {
    case true:
      return 'Exclusive';
    case false:
      return 'Non-exclusive';
    default:
      return '--';
  }
};

export const renderTicketUsageType = (usageType: any) => {
  if (IsNullOrEmptyOrUndefined(usageType)) {
    return ticketUsageTypeRadioOptions[TicketUsageTypeEnums.DEFAULT].key;
  }

  switch (Number(usageType)) {
    case TicketUsageTypeEnums.SINGLE_NON_REPEATABLE:
      return ticketUsageTypeRadioOptions[
        TicketUsageTypeEnums.SINGLE_NON_REPEATABLE
      ].key;
    case TicketUsageTypeEnums.MULTI_REDEMPTION:
      return ticketUsageTypeRadioOptions[TicketUsageTypeEnums.MULTI_REDEMPTION]
        .key;
    case TicketUsageTypeEnums.SINGLE_REPEATABLE:
      return ticketUsageTypeRadioOptions[TicketUsageTypeEnums.SINGLE_REPEATABLE]
        .key;
    default:
      return ticketUsageTypeRadioOptions[TicketUsageTypeEnums.DEFAULT].key;
  }
};

export const renderTicketVisibility = values => {
  if (!values) return '--';
  const key = values.targetedDistribution ? 1 : 0;
  switch (key) {
    case TicketVisibilityEnums.PUBLIC:
      return 'Public';
    case TicketVisibilityEnums.TARGETED:
      return 'Targeted';
    default:
      return '--';
  }
};
// Section func end
